import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user/member-title.jpg'
import _imports_1 from '@/assets/images/user/recommend-tag.jpg'
import _imports_2 from '@/assets/images/user/select-icon.jpg'
import _imports_3 from '@/assets/images/user/pay-success.jpg'


_pushScopeId("data-v-3536f5a2")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "buy-modal-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0 L20 20",
  stroke: "rgb(176,153,123)",
  "stroke-width": "3"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20 0 L0 20",
  stroke: "rgb(176,153,123)",
  "stroke-width": "3"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_7 = { class: "plan-list" }
const _hoisted_8 = { class: "plan-list-flex" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  src: _imports_1,
  class: "recommend-tag"
}
const _hoisted_11 = {
  key: 1,
  class: "active-triangle-container"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "active-triangle" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "active-icon",
  src: _imports_2
}, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "name" }
const _hoisted_16 = { class: "price" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"22px"} }, "¥", -1)
const _hoisted_18 = { class: "original-price" }
const _hoisted_19 = {
  key: 0,
  class: "footer"
}
const _hoisted_20 = { class: "pay-code-dv" }
const _hoisted_21 = {
  key: 0,
  class: "qrcode-loading"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","margin-top":"60px"} }, "加载中", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "wx-logo"
}
const _hoisted_25 = { class: "pay-text-dv" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"50px"} }, "待支付：", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "price-symbol" }, "¥", -1)
const _hoisted_28 = { class: "price-number" }
const _hoisted_29 = {
  key: 1,
  class: "result-container"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0 L20 20",
  stroke: "rgb(176,153,123)",
  "stroke-width": "3"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20 0 L0 20",
  stroke: "rgb(176,153,123)",
  "stroke-width": "3"
}, null, -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "result-success-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "支付成功!")
  ])
], -1)
const _hoisted_34 = { class: "result-text-dv" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
_popScopeId()

import { ref, computed, watch } from "vue";
import {
  createPrepareOrder,
  getProductInfo,
  getWechatPayQRCode,
  queryPrepareOrderStatus,
} from "@/services/personalProduct";
import QRCode from "qrcodejs2";
import { ElMessage } from "element-plus";
import logger from "@evideo/logger";
import _ from "lodash";


export default {
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  currentProduct: {
    type: Object,
    default: null,
  },
},
  emits: ["update:visible", "onSuccess"],
  setup(__props, { emit: emits }) {

const props = __props




const showResult = ref(false);

const productPlans = ref([]);

const productPlansList = computed(() =>
  productPlans.value.map((i) => {
    i.active = i.id === currentPlanId.value;
    return i;
  })
);

const currentPlanId = ref(0);

const currentPlan = computed(() =>
  productPlansList.value.find((i) => i.active)
);

const wxPayQrCode = ref("");
const qrCodeRef = ref();
const qrCodeIns = ref();
const showQrCode = ref(false);

const prepareOrderNoMap = ref({});
const orderTimerMap = ref({});
const qrcodeLoading = ref(false);

const getProductDetail = async () => {
  const res = await getProductInfo(props.currentProduct.production_code);
  const data = res.data.packages;
  // 兼容性问题
  // data.at(-1).recommend = true;
  if (data.length) {
    data[data.length - 1].recommend = true;
  }
  productPlans.value = data.map((i) => ({
    id: i.package_code,
    nowPrice: i.price,
    originalPrice: i.origin_price,
    name: i.name,
    recommend: i.is_recommend,
  }));
};

const genWxPayQrCode = (url, planId) => {
  qrCodeRef.value.innerHTML = "";
  qrcodeLoading.value = true;
  if (showQrCode.value) {
    qrCodeIns.value.clear();
    qrCodeIns.value.makeCode(url);
    qrCodeIns.value = new QRCode("qrcode", {
      text: url,
      width: 150,
      height: 150,
    });
  } else {
    qrCodeIns.value = new QRCode("qrcode", {
      text: url,
      width: 150,
      height: 150,
    });
  }
  qrcodeLoading.value = false;
  showQrCode.value = true;
  startPolling(planId);
};

const startPolling = (planId) => {
  if (orderTimerMap.value[planId]) {
    return;
  }
  orderTimerMap.value[planId] = setInterval(async () => {
    const prepareOrderNo = prepareOrderNoMap.value[planId];
    if (!prepareOrderNo) {
      cancelPolling(planId);
      return;
    }
    const {
      data: { status },
    } = await queryPrepareOrderStatus(prepareOrderNo);
    if (!status) {
      // showResult.value = true;
      return;
    }
    cancelPolling(planId);
    if (status === 1) {
      showResult.value = true;
      emits("onSuccess");
      clearAllTimer();
      // handleCancelBuy();
    } else if (status === 2) {
      ElMessage({
        type: "error",
        message: "支付失败",
      });
    } else if (status === 3) {
      ElMessage({
        type: "info",
        message: "支付已取消",
      });
    }
  }, 3000);
};

const cancelPolling = (planId) => {
  clearInterval(orderTimerMap.value[planId]);
};

const handleSelect = _.debounce(async (item) => {
  qrcodeLoading.value = true;
  currentPlanId.value = item.id;
  logger.error("[order:item]", item);
  try {
    let prepareOrderNo = prepareOrderNoMap.value[item.id];
    if (!prepareOrderNoMap.value[item.id]) {
      const {
        data: { prepare_order_no },
      } = await createPrepareOrder(item.id);
      prepareOrderNo = prepare_order_no;
    }
    logger.error(
      "[order:prepareOrderNo]",
      prepareOrderNo,
      prepareOrderNoMap.value
    );
    prepareOrderNoMap.value[item.id] = prepareOrderNo;
    const {
      data: { qrcode_url },
    } = await getWechatPayQRCode(prepareOrderNo);
    logger.error("[order:qrcode_url]", qrcode_url);

    genWxPayQrCode(qrcode_url, item.id);
    wxPayQrCode.value = qrcode_url;
  } catch (e) {
    logger.error(e);
  }
});

const clearAllTimer = () => {
  Object.keys(orderTimerMap.value).map((i) => {
    clearInterval(orderTimerMap.value[i]);
    orderTimerMap.value[i] = 0;
  });
};

const handleCancelBuy = () => {
  emits("update:visible", false);
  showResult.value = false;
  currentPlanId.value = 0;
  prepareOrderNoMap.value = {};
  showQrCode.value = false;
  clearAllTimer();
};

watch(
  () => props.visible,
  (val) => {
    if (val) {
      getProductDetail();
    }
  }
);

return (_ctx, _cache) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "buy-mask",
          onClick: handleCancelBuy
        }),
        (!showResult.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("svg", {
                width: "20",
                height: "20",
                class: "close",
                onClick: handleCancelBuy
              }, _hoisted_5),
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productPlansList), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: _normalizeClass({
              'plan-item': true,
              'plan-item-recommend': item?.recommend,
              'plan-item-active': item.active,
            }),
                      onClick: $event => (_unref(handleSelect)(item))
                    }, [
                      (item?.recommend)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : _createCommentVNode("", true),
                      (item?.active)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(_toDisplayString(item.nowPrice), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("del", null, "¥" + _toDisplayString(item.originalPrice), 1)
                      ])
                    ], 10, _hoisted_9))
                  }), 128))
                ])
              ]),
              (currentPlanId.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (qrcodeLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                        : _createCommentVNode("", true),
                      (showQrCode.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        ref: qrCodeRef,
                        id: "qrcode"
                      }, null, 512)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", null, "您将为：" + _toDisplayString(__props.currentProduct?.name) + " 续费", 1),
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _hoisted_27,
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(currentPlan)?.nowPrice), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (showResult.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("svg", {
                width: "20",
                height: "20",
                class: "close",
                onClick: handleCancelBuy
              }, _hoisted_32),
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", null, "您已续费：" + _toDisplayString(__props.currentProduct?.name), 1),
                (!__props.currentProduct?.benefit?.forever_enable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 有效期至：" + _toDisplayString(__props.currentProduct?.benefit?.expired_at), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, "永久授权"))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

}